import { useGlobalEvent } from '@highlight/ipc/react'
import HighlightLogoIcon from '@renderer/components/Icons/HighlightLogoIcon'
import { ErrorToast } from '../toasts/error-toast'
import { useToast } from '../use-toast'

type ToastApi = ReturnType<typeof useToast>

export function useErrorToasts(toast: ToastApi) {
  useGlobalEvent(
    'toast:error',
    (data: { title: string; message: string; serverName?: string; debugInfo?: Record<string, unknown> }) => {
      toast.add({
        analytics: { type: 'error' },
        icon: <HighlightLogoIcon size={24} />,
        title: data.title,
        duration: 5000,
        autoExpandDelayMs: 0,
        autoCollapseDelayMs: 5000,
        body: (toastId) => <ErrorToast toastId={toastId} {...data} />,
      })
    },
  )
}
